import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, ReferenceLine } from "recharts";

const PARAM_COLORS = {
  productivity: "#6366f1",
  quality: "#22c55e",
  teamwork: "#f59e0b",
  communication: "#3b82f6",
  punctuality: "#ec4899",
};

const PARAM_LABELS = {
  productivity: "Productivity",
  quality: "Quality",
  teamwork: "Teamwork",
  communication: "Communication",
  punctuality: "Punctuality",
};

const CustomTooltip = ({ active, payload, label }) => {
  if (!active || !payload?.length) return null;
  return (
    <div className="bg-white border border-slate-200 rounded-lg shadow-lg p-3 text-xs">
      <p className="font-semibold text-slate-700 mb-1.5">{label}</p>
      {payload.map((entry, i) => (
        <div key={i} className="flex items-center gap-2 py-0.5">
          <span className="w-2.5 h-2.5 rounded-full" style={{ backgroundColor: entry.color }} />
          <span className="text-slate-600">{entry.name}:</span>
          <span className="font-semibold text-slate-800">{entry.value}</span>
        </div>
      ))}
    </div>
  );
};

export const OverallTrendChart = ({ data }) => {
  if (!data?.length) return null;
  const chartData = data.map(d => ({
    name: d.label,
    "Your Rating": d.overall,
    "Dept Avg": d.dept_avg,
  }));

  return (
    <div data-testid="overall-trend-chart">
      <ResponsiveContainer width="100%" height={280}>
        <BarChart data={chartData} barGap={4} barSize={28}>
          <CartesianGrid strokeDasharray="3 3" stroke="#f1f5f9" />
          <XAxis dataKey="name" tick={{ fontSize: 11, fill: "#94a3b8" }} />
          <YAxis domain={[0, 5]} ticks={[1, 2, 3, 4, 5]} tick={{ fontSize: 11, fill: "#94a3b8" }} />
          <Tooltip content={<CustomTooltip />} />
          <Legend wrapperStyle={{ fontSize: 11 }} />
          <ReferenceLine y={3} stroke="#e2e8f0" strokeDasharray="5 5" label={{ value: "Meets Expectations", position: "insideRight", fill: "#cbd5e1", fontSize: 9 }} />
          <Bar dataKey="Your Rating" fill="#6366f1" radius={[4, 4, 0, 0]} />
          <Bar dataKey="Dept Avg" fill="#cbd5e1" radius={[4, 4, 0, 0]} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export const ParamBreakdownChart = ({ data }) => {
  if (!data?.length) return null;
  const chartData = data.map(d => ({
    name: d.label,
    ...Object.fromEntries(
      Object.entries(d.ratings || {}).map(([k, v]) => [PARAM_LABELS[k] || k, v])
    ),
  }));

  return (
    <div data-testid="param-breakdown-chart">
      <ResponsiveContainer width="100%" height={300}>
        <BarChart data={chartData} barGap={2} barSize={14}>
          <CartesianGrid strokeDasharray="3 3" stroke="#f1f5f9" />
          <XAxis dataKey="name" tick={{ fontSize: 11, fill: "#94a3b8" }} />
          <YAxis domain={[0, 5]} ticks={[1, 2, 3, 4, 5]} tick={{ fontSize: 11, fill: "#94a3b8" }} />
          <Tooltip content={<CustomTooltip />} />
          <Legend wrapperStyle={{ fontSize: 10 }} />
          {Object.entries(PARAM_COLORS).map(([key, color]) => (
            <Bar key={key} dataKey={PARAM_LABELS[key]} fill={color} radius={[3, 3, 0, 0]} />
          ))}
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};
